module.exports = __webpack_public_path__ + "static/img/copy.d5c1e8ea.png";